import { classNames } from '@app/utils/classes'

export const popoverBtnStyle =
  'w-full md:w-auto rounded px-3 py-1.5 text-sm font-medium flex place-items-center place-content-between gap-x-3 bg-lightgray dark:bg-gray-800'

// the popover button on dashboard
export const getPopoverBtnStyle = (disabled?: boolean) => {
  return classNames(
    popoverBtnStyle,
    disabled
      ? ''
      : 'hover:bg-gray-200 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-gray-300'
  )
}
